import styled from "styled-components";

export const CommentSection = styled.section`
  width: 100%;
  min-height: 5rem;
  background: #ffffff;
  border: 1px solid #f6f6f6;
  box-sizing: border-box;
  box-shadow: 2px 4px 4px 0 rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 10px;
`;

export const CommentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: rem(12px) rem(10px) rem(8px) rem(28px);
`;

export const Comment = styled.p`
  font-family: Lato;
  font-size: rem(14px);
  font-style: italic;
  font-weight: 500;
  line-height: rem(16px);
  letter-spacing: 0;
  text-align: left;
  color: #767676;
  margin: 0;
  padding: 0;
  white-space: pre;
`;
